/* VIDA - Traduce al español los pocos textos fijos del formulario de contra entrega (Releasit) que la app no deja editar en su plan actual.
   Solo cambia el texto que se ve; no toca el funcionamiento. Si Releasit cambia sus textos, basta editar la tabla de abajo. */
(function () {
  var SEL = 'dialog.rsi-form-wrapper-dialog';
  var TEXT = { 'Free': 'Gratis', 'Discounts': 'Descuentos', 'Discount': 'Descuento', 'Apply': 'Aplicar', 'Discount code': 'Código de descuento' };
  var PLACEHOLDER = { 'Discount code': 'Código de descuento' };

  /* Precios al estilo chileno: $45,000 -> $45.000 (solo dentro del formulario) */
  function money(t) { return t.replace(/\$\s?\d{1,3}(?:,\d{3})+/g, function (m) { return m.replace(/,/g, '.'); }); }

  function translate(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var raw = n.nodeValue, t = raw.trim();
      if (!t) continue;
      var next = Object.prototype.hasOwnProperty.call(TEXT, t) ? raw.replace(t, TEXT[t]) : money(raw);
      if (next !== raw) n.nodeValue = next;
    }
    root.querySelectorAll('[placeholder]').forEach(function (el) {
      var p = el.getAttribute('placeholder');
      if (Object.prototype.hasOwnProperty.call(PLACEHOLDER, p)) el.setAttribute('placeholder', PLACEHOLDER[p]);
    });
  }

  /* Orden de los campos del formulario (solo visual, con la propiedad `order`; no se mueve nada del codigo de la app).
     Se reconocen por su etiqueta; lo que no este en la lista queda al final, en su orden original. */
  var ORDER = ['nombre', 'apellido', 'teléfono', 'rut', 'región', 'ciudad', 'dirección', 'código postal (opcional)', 'correo electrónico', 'comentarios para la entrega (opcional)'];
  function norm(s) { return s.replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function applyOrder(root) {
    var lw = root.querySelector('.rsi-layout-wrapper'); if (!lw) return;
    var kids = [].slice.call(lw.children), first = -1;
    var ranks = kids.map(function (c, i) {
      var l = c.querySelector('label'), r = l ? ORDER.indexOf(norm(l.textContent)) : -1;
      if (r >= 0 && first < 0) first = i;
      return r;
    });
    if (first < 0) return;
    kids.forEach(function (c, i) {
      var o = i < first ? 0 : (ranks[i] >= 0 ? 1 + ranks[i] : 50 + i);
      if (c.style.order !== String(o)) c.style.order = o;
    });
  }

  function attach(dlg) {
    translate(dlg); applyOrder(dlg);
    /* Solo escribe cuando algo cambia de verdad, para no dispararse a si mismo en bucle */
    new MutationObserver(function () { translate(dlg); applyOrder(dlg); }).observe(dlg, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    var d = document.querySelector(SEL);
    if (d) { attach(d); return; }
    var wait = new MutationObserver(function () {
      var f = document.querySelector(SEL);
      if (f) { wait.disconnect(); attach(f); }
    });
    wait.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
